module.exports = __webpack_public_path__ + "static/react-usage-d8dae024e49ed14f2f5210f1bd80ed54.png";